<template>
    <v-card max-width="4520" raised="raised">
        <v-form ref="issueFileForm" class="fill-height" :lazy-validation="true" v-model="issueFileFormValid">

        <v-card-title>
            <v-icon class="mr-3">mdi-file-multiple</v-icon><span v-text="'Upload Issue Attachments'"></span>
        </v-card-title>

        <v-divider />

        <v-card-text>
            <v-file-input color="#C42111" class="my-4" v-model="selectedFiles" multiple label="File" placeholder="Select a file" :show-size="1024" :rules="[validation.sameName(selectedFiles, $props.existingAttachments)]"></v-file-input>
        </v-card-text>

        <v-divider />

        <v-card-actions>
            <v-spacer></v-spacer>
            <v-btn text class="mr-3" @click="close">Cancel</v-btn>
            <v-btn text :disabled="!selectedFiles" @click="saveFile">Save</v-btn>
        </v-card-actions>

        </v-form>
    </v-card>
</template>

<script>
export default {
    name: 'IssueFileUpload',
    props: ['existingAttachments'],
    components: {
    },
    data: () => ({
        selectedFiles: null,
        selectedFileData: null,
        validation: {
            //sameName: (file, fileList) => ((!file || !fileList.some(f => {return f.name == file.name})) || 'File name already exists. Delete the existing one first')
            sameName: (files, existingAttachments) => ((!files || !files.some(f => {return existingAttachments.some(e => {return f.name == e.name}) }) ) || 'File name already exists. Delete the existing one first')
        },
        issueFileFormValid: true
    }),

    computed: {

    },

    methods: {
        close: function() {
            this.selectedFiles = null;
            this.selectedFileData = null;
            this.$emit('cancel');
        },

        saveFile: function() {
            if(this.$refs.issueFileForm.validate()) {
                this.$emit('save', this.selectedFiles);
            }
        }

    },

    mounted() {
    },
  
};
</script>

<style scoped>

</style>

